<form [formGroup]="basicInfDto">
  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title id="subTitle">基本情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">

        <mat-form-field appearance="outline"
          class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]"
          style="margin-right: 20px;">
          <mat-label>供給地点特定番号</mat-label>
          <input formControlName="suppntSpno" class="font-color-display-only" readonly="true" matInput
            autocomplete="off" />
        </mat-form-field>

        <mat-form-field appearance="outline"
          class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
          <mat-label>使用者名</mat-label>
          <input formControlName="siyousya" class="font-color-display-only" readonly="true" matInput
            autocomplete="off" />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title class="mat-label-ragiogroup" id="tachiai">立会要否</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-radio-group formControlName="attendanceKahi"
        class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
          *ngFor="let code of codeMap?.get('C001941')">{{code.hyojiCont}}</mat-radio-button>
      </mat-radio-group>
    </mat-card-content>
  </mat-card>

  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title class="mat-label-ragiogroup">オートロック</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-radio-group formControlName="autolockUmuFlg"
          class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
          <mat-radio-button class="radio-button-margin" [value]="code.userCode"
            *ngFor="let code of codeMap?.get('S301451')">{{code.hyojiCont}}</mat-radio-button>
        </mat-radio-group>
      </div>


      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
          class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-min-w-[100%] tw-max-w-[100%]">
          <mat-label>暗証番号</mat-label>
          <input formControlName="autolockPin" class="font-color-display-only" readonly="true" matInput
            autocomplete="off" />
        </mat-form-field>

        <mat-form-field appearance="outline"
          class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-min-w-[100%] tw-max-w-[100%]">
          <mat-label>鍵保管場所</mat-label>
          <input formControlName="autolockKeyStoragelocation" class="font-color-display-only" readonly="true" matInput
            autocomplete="off" />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title class="mat-label-ragiogroup" id="takusoMemoInfo">託送メモ情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="basicInfDto">
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center table-responsive">
          <table mat-table [dataSource]="dataSource" style="min-width: 255px;">
            <ng-container matColumnDef="no">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>No</th>
                <td mat-cell class="mat-cell-right" id="no" style="min-width: 10px;width: 10px;"
                  *matCellDef="let i = index">{{this.getNo(i)}}</td>
            </ng-container>

            <ng-container matColumnDef="takusoMemo">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>託送メモ</th>
                <td mat-cell id="takusoMemo" style="min-width: 105px;"
                  *matCellDef="let row">{{row.takusoMemo}}</td>
            </ng-container>

            <!-- <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
        </table>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</form>

<div
  class="btn_area_right tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
  <mat-dialog-actions>
    <button type="button" mat-dialog-close mat-raised-button color="primary" class="btn">閉じる</button>
  </mat-dialog-actions>
</div>